import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import Select from 'react-select';
import { navigate } from "@reach/router"
import $ from 'jquery';
import { useStaticQuery, graphql } from "gatsby"
import { capitalize } from "lodash";

import SelectDropDown from "gatsby-theme-starberry-lomondgroup/src/components/FilterBox/Sections/SelectDropDown"
import AmenitiesCheckBox from "gatsby-theme-starberry-lomondgroup/src/components/FilterBox/Sections/AmenitiesCheckBox"
import SearchResultInputBox from 'gatsby-theme-starberry-lomondgroup/src/components/SearchResult/SearchResultBox';
import "gatsby-theme-starberry-lomondgroup/src/components/FilterBox/FilterBox.scss"

import { GetPrice, PropertySearchUrl, getPriceUrl, searchStateToUrl } from "gatsby-theme-starberry-lomondgroup/src/common/utils/property_utils";
import { toCapitalize } from "gatsby-theme-starberry-lomondgroup/src/common/utils/site_utlis";
import { defaultArea, defaultArea_Slug, SearchType, index_name, FurnishedType, defaultArea_Newhomes, defaultArea_Newhomes_Slug } from "gatsby-theme-starberry-lomondgroup/src/common/constant";


const Filter = ({ searchState, search_type, department, status, onSaleAgreed, location, collections_property, student_property }) => {

    //console.log("searchState ==>", searchState);

    const [scroll, setScroll] = useState(false);

    useEffect(() => {
        window.addEventListener("scroll", () => {
            setScroll(window.scrollY > 160)
        })
      }, [])

    var must_include_arr = [];

    if (searchState?.mustInclude) {
        if (typeof searchState?.mustInclude === "object") {
            if (searchState?.mustInclude?.length > 0) {
                must_include_arr = searchState?.mustInclude
            }
        } else {
            must_include_arr = [searchState?.mustInclude];
        }
    }


    var formFields = {
        query: (searchState?.areas) ? (searchState?.areas) : '',
        sortBy: (searchState?.sortBy) ? (searchState?.sortBy) : '',
        range: {
            price: {
                min: (searchState?.minPrice) ? (searchState?.minPrice) : null,
                max: (searchState?.maxPrice) ? (searchState?.maxPrice) : null
            },
            bedroom: {
                min: (searchState?.bedrooms) ? (searchState?.bedrooms) : null
            }
        },
        menu: {
            building: (searchState?.propertyType) ? (searchState?.propertyType) : null
        },
        refinementList: {
            mustInclude: must_include_arr.length > 0 ? (must_include_arr) : [],
            furnishing: searchState?.furnishing ? searchState?.furnishing : "",
            office_crm_id: searchState?.office_crm_id ? searchState?.office_crm_id : ""
        }
    }

    var selected_area = searchState?.areas ? (searchState?.areas === defaultArea_Slug.replace(/-/g,' ') ? "" : searchState?.areas) : ""

    const [set, setClass] = useState(false);
    const [search_type_val, setSearchType] = useState(search_type ? search_type : "lettings");

    const [min_price_val, setMinPrice] = useState(0);
    const [max_price_val, setMaxPrice] = useState(0);
    const [bed_val, setBedroom] = useState('');
    const [query, setQuery] = useState("");
    const [property_type_val, setPropertyType] = useState("");
    const [furnish_type, setFurnishType] = useState("");
    const [must_include, setMustInclude] = useState([]);

    const [radius_val, setRadius] = useState("");
    const [exclude_val, setExclude] = useState("")

    //const [areaInputVal, setAreaInputVal] = useState(areaVal || "")
    const [showSuggestion, setShowSuggestion] = useState(true)
    const [branch_val, setBranchVal] = useState('');
    const [branch_name, setBranchName] = useState('');

    const [department_val, setDepartment] = useState(department);


    useEffect(() => {
        //console.log("searchState useEffect", searchState)
        setMinPrice(searchState?.minPrice)
        setMaxPrice(searchState?.maxPrice)
        setBedroom(searchState?.bedrooms)
        setPropertyType(searchState?.propertyType)
        setFurnishType(searchState?.furnishing)
        setBranchVal(searchState?.branchVal)
        setRadius(searchState?.radiusVal)
        setExclude(searchState?.excludeVal)

        if(searchState?.areas){
            if(searchState?.areas !== defaultArea_Slug.replace(/-/g,' ')){
                setQuery(searchState?.areas)
            }
        } else{
            setQuery("")
        }
        if(must_include_arr?.length > 0){
            setMustInclude(must_include_arr)
        } else{
            setMustInclude([])
        }
       
    },[searchState])

    //console.log("search_type_val", search_type_val);
    

    const data = useStaticQuery(graphql`
        query PropertySearchCustom{
            glstrapi {
                propertySearch {
                    search_type {
                      name
                      value
                      id
                    }
                    property_type {
                      id
                      label
                      value
                      department
                    }
                    sales_price_list {
                      price:Price
                    }
                    rent_price_list {
                      price
                    }
                    Furnished_Filter
                }

                offices(sort:"sort:ASC", where:{publish:true}){
                    id
                    slug
                    name
                    office_crm_id
                    sort
                }
            }
        }
    `)

    var search_type_list = data.glstrapi.propertySearch.search_type;
    var sales_price_list = data.glstrapi.propertySearch.sales_price_list;
    var rent_price_list = data.glstrapi.propertySearch.rent_price_list;
    var property_type_list = data.glstrapi.propertySearch.property_type;
    var furnished_filter = data.glstrapi.propertySearch.Furnished_Filter;
    var price_list = (search_type_val === "lettings" || search_type_val === "students") ? rent_price_list : sales_price_list;
    
    var office_list = data.glstrapi.offices;

    var default_area_path = "in-" + defaultArea_Slug.toLowerCase() + "/";
    var default_area_path_newhomes = "in-" + defaultArea_Newhomes_Slug.toLowerCase() + "/";

    var reset_path = PropertySearchUrl(department, search_type_val) + (search_type_val === "newhomes" ? default_area_path_newhomes : default_area_path)

    if(location?.state?.collections_property || collections_property){
        //path = PropertySearchUrl("residential", "sales") 
        reset_path = PropertySearchUrl("residential", "collection") + default_area_path
    } else if(location?.state?.student_property || student_property){
        //path = PropertySearchUrl("residential", "lettings")
        reset_path = PropertySearchUrl("residential", "students") + default_area_path
    }
    

    /* ========= search types ======= */
    var search_type_options = [];
    search_type_list.map((item, index) => {
        search_type_options.push({ label: item.name, value: item.value })
    })


    /* ==== Min Price === */
    var min_price = [{ value: '', label: 'Min Price' }];
    price_list.map((item, index) => {
        if (parseInt(max_price_val) > 0) {
            if (parseInt(item.price) < parseInt(max_price_val)) {
                min_price.push({ value: parseInt(item.price), label: (search_type_val === "lettings" || search_type_val === "students") ? GetPrice(parseInt(item.price)) + " pcm" : GetPrice(parseInt(item.price))})
            }
        } else {
            min_price.push({ value: parseInt(item.price), label: (search_type_val === "lettings" || search_type_val === "students") ? GetPrice(parseInt(item.price)) + " pcm" : GetPrice(parseInt(item.price)) })
        }

    })

    /* ==== Max Price === */
    var max_price = [{ value: '', label: 'Max Price' }];
    price_list.slice(0).map((item, index) => {
        if (parseInt(min_price_val) > 0) {
            if (parseInt(item.price) > parseInt(min_price_val)) {
                max_price.push({ value: parseInt(item.price), label: (search_type_val === "lettings" || search_type_val === "students") ? GetPrice(parseInt(item.price)) + " pcm" : GetPrice(parseInt(item.price))  })
            }

        } else {
            max_price.push({ value: parseInt(item.price), label: (search_type_val === "lettings" || search_type_val === "students") ?  GetPrice(parseInt(item.price)) + " pcm" : GetPrice(parseInt(item.price))  })
        }

    })



    /* ==== Bedrroms === */
    var bed = [{ value: '', label: 'Bedrooms' }, { value: 0, label: "Studio" }];
    for (var i = 1; i <= 5; i++) {
        bed.push({ value: i, label: i + "+" })
    }


    /* ======== Property Type ======= */
    var filter_property_type = department === "residential" ? property_type_list.filter(item => item.department === "residential" || item.department === "both") : property_type_list.filter(item => item.department === "commercial" || item.department === "both");

    var property_type = [{ value: '', label: 'All' }];
    filter_property_type.map((item, index) => {
        property_type.push({ value: item.value, label: item.label })
    })

    var office_list_option = [{ value: '', label: 'All' }];
    //var office_selected_val = "";
    office_list.map((item, index) => {
        office_list_option.push({ value: item.office_crm_id, label: item.name })
        //office_selected_val = item.name;
    })

    //console.log("office_list_option", office_list_option);

    const handleChange = (value) => {
        setQuery(value)
        //setClass(false);
        $(".search-field").removeClass("actv_cls")
    }

    const handleChangeBranch = (event) =>{

        //console.log("handleChangeBranch", event.target)
        if(event?.target?.value){
            setBranchVal(event?.target?.value.toLowerCase());
            setBranchName(event.target.selectedOptions[0].text);
        } else{
            setBranchVal(event.value.toLowerCase());
            setBranchName(event.label);
        }
    }

    const handleChangeType = (event) => {

        var event_label = "";
        var event_value = "";

        if(event?.target?.value){
            event_label = event.target.selectedOptions[0].text;
            event_value = event.target.value;
        } else{
            event_label = event.label;
            event_value = event.value;
        }

        console.log("event_label", event, event_label)

        var replace_str = event_label.replace(/ /g,'-').toLowerCase()+"-";
        var select_value = event_value.replace(replace_str,'');
        var department_value = department_val;

        if(event_label.includes("Commercial")){
            department_value = "commercial";
            select_value = event_value.replace("commercial-",'');
            setSearchType(event_value.replace("commercial-",''))
            setDepartment("commercial")
        } else if(event_label.includes("Residential")){
            department_value = "residential";
            select_value = event_value.replace("residential-",'');
            setSearchType(event_value.replace("residential-",''))
            setDepartment("residential")
        } else if(event_label.includes("Auctions")){
            department_value = "auction";
            select_value = event_value.replace("auction-",'');
            setSearchType(event_value.replace("auction-",''))
            setDepartment("auction")
        } else{
            department_value = "residential";
            setSearchType(select_value); 
        }

        var path = "";

        if(event_label.toLowerCase() === "collection"){
            //path = PropertySearchUrl("residential", "sales") + default_area_path
            path = PropertySearchUrl("residential", "collection") + default_area_path
        } else if(event_label.toLowerCase() === "students"){
            //path = PropertySearchUrl("residential", "lettings") + default_area_path
            path = PropertySearchUrl("residential", "students") + default_area_path
        } else if(select_value === "newhomes"){
            path = PropertySearchUrl("residential", "sales") + default_area_path_newhomes;
        } else{
            path = PropertySearchUrl(department_value, select_value) + default_area_path;
        }

        // if(select_value === "newhomes"){
        //     path = PropertySearchUrl(department, select_value) + default_area_path_newhomes;
        // }

        if(event_label.toLowerCase() === "new homes"){
            navigate(path, {state: {new_homes:true}}) 
        } else if(event_label.toLowerCase() === "collection"){
            navigate(path, {state: {collections_property:true}}) 
        } else if(event_label.toLowerCase() === "students"){
            navigate(path, {state: {student_property:true}}) 
        } else{
            navigate(path) 
        }
    }

    //console.log("search_type_val", search_type_val)

    const handleClick = (e) => {
        //setClass(false);
        $(".search-field").removeClass("actv_cls")
    }

    const onFilterSubmit = (searchState, branch_val) => {

        var path = PropertySearchUrl(department_val, search_type_val);

        if(location?.state?.new_homes){
            path = PropertySearchUrl("residential", "sales")
        } else if(location?.state?.collections_property || collections_property){
            //path = PropertySearchUrl("residential", "sales") 
            path = PropertySearchUrl("residential", "collection")
        } else if(location?.state?.student_property || student_property){
            //path = PropertySearchUrl("residential", "lettings")
            path = PropertySearchUrl("residential", "students")
        }

        if(location?.state?.new_homes){
            navigate(searchStateToUrl(index_name, searchState, path), {state: {new_homes:location?.state?.new_homes, office_crm_id: branch_val}})

        } else if(location?.state?.collections_property || collections_property){
            navigate(searchStateToUrl(index_name, searchState, path), {state: {collections_property:location?.state?.collections_property, office_crm_id: branch_val}})
        } else if(location?.state?.student_property || student_property){
            navigate(searchStateToUrl(index_name, searchState, path), {state: {student_property:location?.state?.student_property, office_crm_id: branch_val}})
        } 
        else{
            navigate(searchStateToUrl(index_name, searchState, path), {state: {office_crm_id: branch_val}})
        }
    }

    const toggleExclude = (event, value) => {
        //console.log("checkbox trigger", value, event.target)
        if(event.target.checked){
            setExclude(value)
        } else{
            setExclude("")
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        let radius_miles = "";
        if(radius_val){
            if(parseInt(radius_miles) <=1){
                radius_miles = radius_val+"-mile";
            } else{
                radius_miles = radius_val+"-miles";
            }
        }

        formFields.query = query ? query : (search_type_val === "newhomes" ? defaultArea_Newhomes  : defaultArea);
        formFields.range.price['min'] = min_price_val;
        formFields.range.price['max'] = max_price_val;
        formFields.range.bedroom['min'] = bed_val;
        formFields.menu['building'] = property_type_val;
        formFields.refinementList.mustInclude = must_include;
        formFields.refinementList.furnishing = furnish_type;
        formFields.refinementList.office_crm_id = branch_val;

        formFields.refinementList.radiusVal = query ? radius_miles : "";
        formFields.refinementList.exclude_val = exclude_val ? exclude_val : "";
        //formFields.includes = include;

        onFilterSubmit(formFields)

        //setClass(false);
        $(".search-field").removeClass("actv_cls")
    }

    const handleShow = (e) => {
        //setClass(!set);
        //e.preventDefault();
        $(".search-field").toggleClass("actv_cls")

    }


    const resetFilter = (e) => {
        e.preventDefault();

        setMinPrice(0);
        setMaxPrice(0);
        setPropertyType("");
        setBedroom("");
        setMustInclude([]);
        setFurnishType("");
        setQuery("")

        formFields.query = defaultArea;
        formFields.range.price['min'] = 0;
        formFields.range.price['max'] = 0;
        formFields.range.bedroom['min'] = "";
        formFields.menu['building'] = "";
        formFields.refinementList.mustInclude = [];
        formFields.refinementList.furnishing = "";

        formFields.refinementList.radiusVal = "";
        formFields.refinementList.exclude_val = "";

        onFilterSubmit(formFields)
    }

    //console.log("department ==>", department)

    var search_type_placeholder = search_type_val === "sales" ? "Buy" : "Rent";

    if(location?.state?.new_homes){
        search_type_placeholder = "New Homes";
    }

    if(location?.state?.collections_property || collections_property){
        search_type_placeholder = "Collection";
    }

    if(location?.state?.student_property || student_property){
        search_type_placeholder = "Students";
    }

    if(department_val === "commercial"){
        search_type_placeholder = "Commercial "+capitalize(search_type_val);
    }
    if(department_val === "auction"){
        search_type_placeholder = "Auctions";
    }

    //console.log("search_type_placeholder ==>", search_type_placeholder, search_type_val, location?.state)

    return (
        <React.Fragment>
            {/* <section className={`filter ${scroll ? "fixed" : ""}`}> */}
            <section className={`filter`}>
                <Container>
                    <Row>
                        <Col>
                            <Form action="javascript:;" method="post" onSubmit={handleSubmit}>
                                <div className={`filter-wrapper ${location?.state?.prestige_property ? "prestige_property" :""}`}>
                                    <div className="input-box">
                                        {/* <input type="text" value={query} placeholder="Area or postcode" onChange={handleChange}></input> */}

                                        <SearchResultInputBox areaVal={query} placeHolder={`Area or postcode`} department={department} handleChange={handleChange} />
                                    </div>
                                    
                                    <div className="filter-btn d-md-none">
                                        <span className="btn btn-outline filter_toggle" onClick={handleShow} >Filters</span>
                                        <button className="btn" type="submit">Search</button>
                                    </div>

                                    <div className={`filter-menu d-none d-md-flex ${department}`}>
                                        
                                        <div className="select-option type-field dropdown d-none d-xl-block search_type" onClick={handleClick}>
                                            <Select 
                                                options={search_type_options}
                                                placeholder={search_type_placeholder} 
                                                className="react-select"
                                                classNamePrefix="react-select"
                                                onChange={(e) => handleChangeType(e)}
                                                isSearchable={false}

                                            />
                                        </div>
                                        

                                        <div className="select-option dropdown d-none d-xl-block" onClick={handleClick}>
                                            <SelectDropDown
                                                options={min_price}
                                                placeholder="Min Price"
                                                className="react-select"
                                                classNamePrefix="react-select"
                                                handleChange={(e) => { setMinPrice(e); }}
                                                selectedValue={parseInt(min_price_val) > 0 ? GetPrice(min_price_val) : ""}
                                                //menuIsOpen={true}

                                            />
                                        </div>

                                        <div className="select-option dropdown d-none d-xl-block" onClick={handleClick}>
                                            <SelectDropDown
                                                options={max_price}
                                                placeholder="Max Price"
                                                className="react-select"
                                                classNamePrefix="react-select"
                                                handleChange={(e) => { setMaxPrice(e); }}
                                                selectedValue={parseInt(max_price_val) > 0 ? GetPrice(max_price_val) : ""}
                               
                                            />
                                        </div>

                                        {department === "residential" &&
                                            <div className="select-option dropdown d-none d-xl-block bed-field" onClick={handleClick}>
                                                <SelectDropDown
                                                    options={bed}
                                                    placeholder="Bedrooms"
                                                    className="react-select"
                                                    classNamePrefix="react-select"
                                                    handleChange={(e) => { setBedroom(e); }}
                                                    selectedValue={parseInt(bed_val) === 0 ? "Studio" : parseInt(bed_val) > 0 ? bed_val + "+" : ""}
                                                />
                                            </div>
                                        }

                                        {/* <div className="select-option dropdown d-none d-xl-block type-field">
                                            <SelectDropDown 
                                                options={property_type} 
                                                placeholder="Property Type" 
                                                className="react-select"
                                                classNamePrefix="react-select"
                                                handleChange={setPropertyType}
                                                selectedValue={property_type_val ?  toCapitalize(property_type_val) : ""}
                                            />
                                        </div> */}
                                        <a href="javascript:;" className="filter-box" onClick={handleShow}>
                                            <span className="filter-text"> More Filters</span>
                                            <i className="icon-filter">
                                            </i>
                                        </a>
                                        <button className="search-icon" type="submit">
                                            <i className="icon-search"></i>
                                        </button>
                                    </div>


                                    {/* Mobile Filter */}
                                    <div className={"search-field"} id="search_filter">
                                        
                                        <div className="d-block d-xl-none search_type">
                                            <span className="h3">Search Type</span>
                                            <div className="search-select mb-5">
                                                {/* <Select options={search_type_options}
                                                    placeholder={search_type_placeholder} 
                                                    className="react-select"
                                                    classNamePrefix="react-select"
                                                    onChange={(e) => handleChangeType(e)}
                                                    //menuIsOpen={menuIsOpen}
                                                    isSearchable={false}
                                                /> */}

                                                <select className="react-select" onChange={(e) => handleChangeType(e)}>
                                                    {search_type_options.map((item) => {
                                                        return(
                                                            <option value={item.value} label={item.label}>{item.label}</option>
                                                        )
                                                    })}
                                                </select>
                                            </div>
                                        </div>
                                        

                                        <div className="d-block d-xl-none">
                                            <span className="h3">Min Price</span>
                                            <div className="search-select mb-5">
                                                {/* <SelectDropDown
                                                    options={min_price}
                                                    placeholder="Min Price"
                                                    className="react-select"
                                                    classNamePrefix="react-select"
                                                    handleChange={setMinPrice}
                                                    selectedValue={parseInt(min_price_val) > 0 ? GetPrice(min_price_val) : ""}
                                                    //menuIsOpen={true}
                                                /> */}
                                                <select className="react-select" onChange={(e) => setMinPrice(e.target.value)}>
                                                    {min_price.map((item) => {
                                                        return(
                                                            <option value={item.value} label={item.label}>{item.label}</option>
                                                        )
                                                    })}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="d-block d-xl-none">
                                            <span className="h3">Max Price</span>
                                            <div className="search-select mb-5">
                                                {/* <SelectDropDown
                                                    options={max_price}
                                                    placeholder="Max Price"
                                                    className="react-select"
                                                    classNamePrefix="react-select"
                                                    handleChange={setMaxPrice}
                                                    selectedValue={parseInt(max_price_val) > 0 ? GetPrice(max_price_val) : ""}
                                                /> */}
                                                <select className="react-select" onChange={(e) => setMaxPrice(e.target.value)}>
                                                    {max_price.map((item) => {
                                                        return(
                                                            <option value={item.value} label={item.label}>{item.label}</option>
                                                        )
                                                    })}
                                                </select>
                                            </div>
                                        </div>

                                        {department === "residential" &&
                                            <div className="d-block d-xl-none">
                                                <span className="h3">Bedrooms</span>
                                                <div className="search-select mb-5">
                                                    {/* <SelectDropDown
                                                        options={bed}
                                                        placeholder="Bedrooms"
                                                        className="react-select"
                                                        classNamePrefix="react-select"
                                                        handleChange={setBedroom}
                                                        selectedValue={parseInt(bed_val) === 0 ? "Studio" : parseInt(bed_val) > 0 ? bed_val + "+" : ""}
                                                    /> */}

                                                    <select className="react-select" onChange={(e) => setBedroom(e.target.value)}>
                                                        {bed.map((item) => {
                                                            return(
                                                                <option value={item.value} label={item.label}>{item.label}</option>
                                                            )
                                                        })}
                                                    </select>
                                                </div>
                                            </div>
                                        }

                                        <div className="prop_type_cls">
                                            <span className="h3">Property Type</span>
                                            <div className="search-select mb-5">
                                                {/* <SelectDropDown
                                                    options={property_type}
                                                    placeholder="All"
                                                    className="react-select"
                                                    classNamePrefix="react-select"
                                                    handleChange={setPropertyType}
                                                    selectedValue={property_type_val ? toCapitalize(property_type_val) : ""}
                                                    //menuIsOpen={true}
                                                /> */}
                                                <select className="react-select" onChange={(e) => setPropertyType(e.target.value)}>
                                                    {property_type.map((item) => {
                                                        return(
                                                            <option value={item.value} selected={item.value === property_type_val}>{item.label}</option>
                                                        )
                                                    })}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="prop_type_cls">
                                            <span className="h3">By Branch</span>
                                            <div className="search-select mb-5">
                                                {/* <Select 
                                                    options={office_list_option}
                                                    placeholder={"All"} 
                                                    className="react-select"
                                                    classNamePrefix="react-select"
                                                    onChange={(e) => handleChangeBranch(e)}
                                                    isSearchable={false}
                                                    //menuIsOpen={true}
                                                /> */}
                                                <select className="react-select" onChange={(e) => handleChangeBranch(e)}>
                                                    {office_list_option.map((item) => {
                                                        return(
                                                            <option value={item.value} selected={item.value.toLowerCase() === branch_val}>{item.label}</option>
                                                        )
                                                    })}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="amenities_cls">
                                            <span className="h3">Amenities</span>
                                            <AmenitiesCheckBox setMustInclude={setMustInclude} must_include={must_include} search_type_val={search_type_val} />
                                        </div>
                                        
                                        
                                        <div className={`bottom-box ${furnished_filter ? "" : "no_mrgn"}`}>
                                            {furnished_filter &&
                                            <>
                                                <span className="h3">Furnishing</span>
                                                <div className="search-select">
                                                    {/* <SelectDropDown
                                                        options={FurnishedType}
                                                        placeholder="Select Type"
                                                        className="react-select"
                                                        classNamePrefix="react-select"
                                                        handleChange={setFurnishType}
                                                        selectedValue={furnish_type ? toCapitalize(furnish_type) : ""}
                                                    /> */}
                                                    <select className="react-select" onChange={(e) => setFurnishType(e.target.value)}>
                                                        {FurnishedType.map((item) => {
                                                            return(
                                                                <option value={item.value} selected={item.value === furnish_type}>{item.label}</option>
                                                            )
                                                        })}
                                                    </select>
                                                </div>
                                            </>
                                            }
                                            
                                            {search_type_val === "sales" && 
                                                <div className="container-box sale_agreed">
                                                    <label class="container-wrap"> Exclude Sale Agreed
                                                        <input type="checkbox" value={"For Sale"} checked={exclude_val === "sale-agreed" ? "checked" : ""} onChange={(e) => toggleExclude(e,"sale-agreed")} />
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                            }
                                            {search_type_val === "lettings" && 
                                                <div className="container-box sale_agreed">
                                                    <label class="container-wrap"> Exclude Let Agreed
                                                        <input type="checkbox" value={"To Let"} 
                                                        checked={exclude_val === "let-agreed"} onChange={(e) => toggleExclude(e,"let-agreed")} />
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                            }
                                            

                                            <div className="btn-wrap">
                                                {/* <button className="btn btn-primary" onClick={resetFilter} >Reset</button> */}
                                                <button className="btn" type="submit">Update</button>
                                                <a href={reset_path} className="btn btn-primary">Reset</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Form>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};
export default Filter;